import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ScannerModal from "../../pages/Events/ScannerModal";
import axiosClient from "../../Services/Axios/axios";
import { organizationDetail } from "../../Context/SelectedOrganization";

/* ============ CONSTANTS ============ */

const ICON_STYLE = {
  width: "20px",
  height: "20px",
  marginRight: "10px",
  objectFit: "contain",
};

const sidebarSections = [
  {
    title: "Worldtrust",
    items: [
      {
        id: 2,
        path: "/manage-campaign",
        label: "Manage Campaign",
        icon: "/images/manage_camp.png",
      },
      {
        id: 3,
        path: "/manage-event",
        label: "Manage Event",
        icon: "/images/manage_event.png",
      },
    ],
  },
  {
    title: "Profile",
    items: [
      {
        id: 4,
        path: "/directory",
        label: "Profile",
        icon: "/images/directory.png",
      },
      {
        id: 5,
        path: "/employees",
        label: "Employees",
        icon: "/images/employees.png",
      },
      {
        id: 6,
        path: "/employee-role",
        label: "Employee Role",
        icon: "/images/user_role.png",
      },
    ],
  },
  // {
  //   title: "Store",
  //   items: [
  //     {
  //       id: 7,
  //       path: "/mall-dashboard",
  //       label: "Mall Dashboard",
  //       icon: "/images/dashboard.png",
  //     },
  //     { id: 8, path: "/orders", label: "Orders", icon: "/images/orders.png" },
  //     {
  //       id: 9,
  //       path: "/products",
  //       label: "Products",
  //       icon: "/images/products.png",
  //     },
  //     {
  //       id: 10,
  //       path: "/track-order",
  //       label: "Track Order",
  //       icon: "/images/track_order.png",
  //     },
  //   ],
  // },
];

/* ============ COMPONENT ============ */

const SellerSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { organizationData, setOrganizationData } =
    useContext(organizationDetail);

  const [accessModules, setAccessModules] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [companiesApproved, setCompaniesApproved] = useState([]);
  const [showscan, setShowscan] = useState(false);

  const isActive = (path) =>
    location.pathname.startsWith(path) ? "sidebar-link active" : "sidebar-link";

  const hasAccess = (id) => accessModules?.some((mod) => mod.id === id);

  const handleLogout = () => {
    Swal.fire({
      title: "Do you want to logout?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/");
        Swal.fire({
          title: "Logged out",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
      }
    });
  };

  const getOrganizationData = async () => {
    try {
      const response = await axiosClient.get(
        `/company/${process.env.REACT_APP_API_VERSION}/user-organizations-list`
      );
      if (!response.data.error) {
        setCompaniesApproved(
          response.data.data.rows.filter((org) => org.status === 1)
        );
      } else {
        console.error(
          "Error fetching organization data:1234",
          response.data.message
        );
      }
    } catch (error) {
      // console.error("Error fetching organization data:", error);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    setUserDetails(user);
    setAccessModules(user?.AccessModules || []);
    getOrganizationData();
  }, []);
  return (
    <div className="sidebar">
      {/* ================= COMPANY ================= */}
      <div className="sidebar-section">
        <p className="sidebar-title">Company</p>

        {userDetails?.userTypeLabel === "owner" && (
          <select
            className="company-select"
            value={organizationData?.id || ""}
            onChange={(e) => {
              const selected = companiesApproved.find(
                (c) => c.id == e.target.value
              );
              setOrganizationData(selected);
              sessionStorage.setItem("organization_id", selected.id);
            }}
          >
            {companiesApproved.map((company) => (
              <option key={company.id} value={company.id}>
                {company.organization_name}
              </option>
            ))}
          </select>
        )}

        {userDetails?.userTypeLabel === "employee" && (
          <p className="sidebar-title">
            {
              companiesApproved.find(
                (c) => c.id === userDetails.organization_id
              )?.organization_name
            }
          </p>
        )}

        {hasAccess(1) && (
          <Link to="/dashboard" className={isActive("/dashboard")}>
            <img
              src="/images/dashboard.png"
              alt="dashboard"
              style={ICON_STYLE}
            />
            Dashboard
          </Link>
        )}
      </div>

      <hr className="divider" />

      {/* ============ SHOW ONLY SECTIONS THAT HAVE ACCESS ============ */}
      {sidebarSections.map((section, index) => {
        const hasAnyAccess = section.items.some((item) => hasAccess(item.id));
        if (!hasAnyAccess) return null;

        // Check if it's the last visible section
        const isLastVisible =
          index ===
          sidebarSections.filter((sec) =>
            sec.items.some((item) => hasAccess(item.id))
          ).length -
            1;

        return (
          <React.Fragment key={section.title}>
            <div className="sidebar-section">
              <p className="sidebar-title">{section.title}</p>

              {section.items.map((item) =>
                hasAccess(item.id) ? (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={isActive(item.path)}
                  >
                    <img src={item.icon} alt={item.label} style={ICON_STYLE} />
                    {item.label}
                  </Link>
                ) : null
              )}
            </div>

            {/* Render divider only if not last visible section */}
            {!isLastVisible && <hr className="divider" />}
          </React.Fragment>
        );
      })}

      {/* ============ SCANNER MODAL ============ */}
      <ScannerModal open={showscan} onClose={() => setShowscan(false)} />
    </div>
  );
};

export default SellerSidebar;
